export const deg2radLocal = (d: number): number => (d * Math.PI) / 180;
